<script>
    import Icon from './Icon.svelte';
    import checkmarkIcon from '../assets/icons/checkmark.svg?raw';

    let { checked = $bindable(false), disabled = false } = $props();
</script>

<span class="checkbox-container">
    <input 
        type="checkbox" 
        bind:checked
        {disabled}
    />
    <span class="checkmark">
        {#if checked}
            <Icon data={checkmarkIcon} />
        {/if}
    </span>
</span>

<style>
    .checkbox-container {
        position: relative;
        display: inline-flex;
        cursor: pointer;
    }

    .checkbox-container input[type="checkbox"] {
        opacity: 0;
        position: absolute;
        cursor: pointer;
    }

    .checkmark {
        width: 24px;
        height: 24px;
        border: 2px solid var(--accent-background);
        border-radius: 4px;
        background-color: var(--box-color);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
    }

    .checkbox-container input[type="checkbox"]:checked + .checkmark {
        background-color: var(--accent-background);
    }

    .checkbox-container input[type="checkbox"]:checked:not(:disabled) + .checkmark:hover {
        background-color: color-mix(in srgb, var(--accent-background) 85%, #000);
        border-color: color-mix(in srgb, var(--accent-background) 85%, #000);
    }

    .checkbox-container input[type="checkbox"]:disabled + .checkmark {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .checkbox-container input[type="checkbox"]:focus-visible + .checkmark {
        outline: 2px solid var(--accent-background);
        outline-offset: 2px;
    }

    @supports (color: color-mix(in srgb, red 50%, blue)) {
        .checkbox-container input[type="checkbox"]:focus-visible + .checkmark {
            outline: 4px solid color-mix(in srgb, var(--accent-background) 35%, transparent);
            outline-offset: 0;
        }
    }

    .checkmark :global(svg) {
        width: 18px;
        height: 18px;
        color: var(--accent-color);
    }
</style>